import { Injectable, Inject } from '@angular/core';
import { Types, Subtypes, Mode, Source, CITY } from '../common/const';
import * as booleanDisjoint from '@turf/boolean-disjoint';
import * as intersect from 'turf-intersect';
import * as _ from 'lodash';
import * as moment from 'moment';

@Injectable()
export class StatsService {


  constructor(
    @Inject(CITY) public cityMetadata
  ) {}

  _bboxFilter(feature, filters) {
    return intersect(feature.geometry, filters.bbox);
  }

  _modeFilter(feature, filters) {
    const now = moment();
    if (filters.mode === Mode.REALTIME ) {
      return moment().isBetween(feature.properties.start, feature.properties.finish);
    } else if (filters.mode === Mode.UPCOMING ) {
      return moment().isBefore(feature.properties.start);
    }
  }

  _runFilters(data: any, filters: any, filtersFns: Array<any>) {
    return data.filter(feature => {
      for (const fn of filtersFns) {
        if (!fn(feature, filters)) {
          return false;
        }
      }
      return true;
    }).map(feature => {
      return feature.properties;
    });
  }

  filterTypes(mode, filters) {
    this.cityMetadata.find(meta => meta.mode === mode).types.filter(type => {
      // TODO: remove this 'waze'. Currently only filtering with bbox data from 'waze'
      if (type.original && (!type.source || type.source === 'waze')) {
        type.data = this._runFilters(type.original, filters, [this._bboxFilter]);
      }
    });
  }

  updateTypes(data, mode) {
    const groupedData = _.groupBy(data, d => {
      return d.properties.type;
    });
    Object.keys(groupedData).forEach(type => {
      const _metadata = this.cityMetadata.find(meta => meta.mode === mode).types.find(_type => _type.idText === type);
      _metadata.data = groupedData[type];
      _metadata.original = groupedData[type];
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/real-time/stats.service.ts